export const data_ifc = {
   "splat":"https://assets.deepworldmodel.ai/playground/scene/ifc-260209183530_6989b84cd924b619fd6e00a6-20260209_103606-pipeline-splat_30000.sog",
   "mesh":"https://assets.deepworldmodel.ai/playground/scene/ifc-260209183530_6989b84cd924b619fd6e00a6-20260209_103606-pipeline-splat_30000_mesh_1.glb",
   "avatar":"https://assets.deepworldmodel.ai/playground/avatar/labubuRun_20260630_1720.glb",
   "scale":0.5,
   "camera":{
      "position":{
         "x":2,
         "y":0.5,
         "z":-2
      },
      "target":{
         "x":3,
         "y":0,
         "z":1
      }
   },
   "path":{
      "position":[
         [
            -4.093603134155273,
            -0.758616030216217,
            -3.616898775100708
         ],
         [
            -3.870018482208252,
            -0.7356501817703247,
            -3.169907569885254
         ],
         [
            -3.818474292755127,
            -0.6798391342163086,
            -2.666034460067749
         ],
         [
            -3.762274980545044,
            -0.6467995047569275,
            -2.162127733230591
         ],
         [
            -3.8061954975128174,
            -0.6124640703201294,
            -1.6537257432937622
         ],
         [
            -3.9798943996429443,
            -0.5744747519493103,
            -1.1792068481445312
         ],
         [
            -4.269900321960449,
            -0.49718284606933594,
            -0.7614068388938904
         ],
         [
            -4.445101261138916,
            -0.4234273135662079,
            -0.2960969805717468
         ],
         [
            -4.378758907318115,
            -0.3860260546207428,
            0.20209619402885437
         ],
         [
            -4.111663341522217,
            -0.41777005791664124,
            0.6278552412986755
         ],
         [
            -3.6431519985198975,
            -0.4273952543735504,
            0.8361396193504333
         ],
         [
            -3.17582631111145,
            -0.6113547086715698,
            0.9004703760147095
         ],
         [
            -2.677609443664551,
            -0.6031177043914795,
            0.7760547995567322
         ],
         [
            -2.203047275543213,
            -0.5908879637718201,
            0.6085091233253479
         ],
         [
            -1.7353572845458984,
            -0.6353812217712402,
            0.40612757205963135
         ],
         [
            -1.3456133604049683,
            -0.7298153042793274,
            0.09684287756681442
         ],
         [
            -1.0044862031936646,
            -0.7572715878486633,
            -0.2773577868938446
         ],
         [
            -0.7906404137611389,
            -0.8009378910064697,
            -0.7448781728744507
         ],
         [
            -1.1253888607025146,
            -0.57108473777771,
            -1.0598794221878052
         ],
         [
            -1.5763930082321167,
            -0.5666097402572632,
            -1.290040373802185
         ],
         [
            -2.0457277297973633,
            -0.6075064539909363,
            -1.463196039199829
         ],
         [
            -2.5565361976623535,
            -0.6061140894889832,
            -1.5253098011016846
         ],
         [
            -3.052337646484375,
            -0.6206277012825012,
            -1.6410115957260132
         ],
         [
            -3.4419915676116943,
            -0.6391634941101074,
            -1.9607561826705933
         ],
         [
            -3.473297357559204,
            -0.6690048575401306,
            -2.466754674911499
         ],
         [
            -3.1931636333465576,
            -0.7112712264060974,
            -2.888967752456665
         ],
         [
            -2.9133386611938477,
            -0.7421520352363586,
            -3.3102540969848633
         ],
         [
            -2.9434657096862793,
            -0.7926257848739624,
            -3.8071868419647217
         ],
         [
            -3.300598621368408,
            -0.7931398749351501,
            -4.161003112792969
         ],
         [
            -3.7849903106689453,
            -0.745806097984314,
            -4.004770278930664
         ],
         [
            -4.093603134155273,
            -0.758616030216217,
            -3.616898775100708
         ]
      ],
      "target":[
         [
            -3.9057555448189025,
            -0.7576988935470581,
            -2.648650002331902
         ],
         [
            -3.7596825462337526,
            -0.7356501817703247,
            -2.176013218742925
         ],
         [
            -3.7081383567806276,
            -0.6798391342163086,
            -1.67214010892542
         ],
         [
            -3.6519390445705446,
            -0.6467995047569275,
            -1.1682333820882618
         ],
         [
            -4.231813395155036,
            -0.6124640703201294,
            -0.7488227621921314
         ],
         [
            -4.586370161162405,
            -0.5744747519493103,
            -0.38410487311906905
         ],
         [
            -4.813789354816661,
            -0.49718284606933594,
            0.07775030964190921
         ],
         [
            -4.6334391483539035,
            -0.4234273135662079,
            0.6860073113643972
         ],
         [
            -4.100281353161076,
            -0.3860260546207428,
            1.1625389314321384
         ],
         [
            -3.4212110517390446,
            -0.41777005791664124,
            1.3512331753920335
         ],
         [
            -2.653934926089095,
            -0.4273952543735504,
            0.9825963829751728
         ],
         [
            -2.1789090859308966,
            -0.6113547086715698,
            0.8220099010078297
         ],
         [
            -1.7377517849156956,
            -0.6031177043914795,
            0.43448843515426283
         ],
         [
            -1.3125493810278437,
            -0.5908879637718201,
            0.15352176101327836
         ],
         [
            -0.9187866804505375,
            -0.6353812217712402,
            -0.17111799832383834
         ],
         [
            -0.5782066436767895,
            -0.7298153042793274,
            -0.5443177350104687
         ],
         [
            -0.4436720649567226,
            -0.7572715878486633,
            -1.1052995133176047
         ],
         [
            -0.533357199000427,
            -0.8009378910064697,
            -1.7112142155647734
         ],
         [
            -2.0165209051360886,
            -0.57108473777771,
            -1.5136234903403691
         ],
         [
            -2.477633630098545,
            -0.5666097402572632,
            -1.7233593573441173
         ],
         [
            -3.0063748092133498,
            -0.6075064539909363,
            -1.7409678678821763
         ],
         [
            -3.5274545884514783,
            -0.6061140894889832,
            -1.7647204909788425
         ],
         [
            -3.9698126866818417,
            -0.6206277012825012,
            -2.0388049473731424
         ],
         [
            -3.852724646610927,
            -0.6391634941101074,
            -2.8725118175946722
         ],
         [
            -3.1373999632042597,
            -0.6690048575401306,
            -3.4086532578096573
         ],
         [
            -2.47971902723918,
            -0.7112712264060974,
            -3.5896793864519116
         ],
         [
            -2.617375716815072,
            -0.7421520352363586,
            -4.26545351886212
         ],
         [
            -3.491364779437257,
            -0.7926257848739624,
            -4.643731287506029
         ],
         [
            -4.181262695428648,
            -0.7931398749351501,
            -4.6347443804271276
         ],
         [
            -4.495325605010975,
            -0.745806097984314,
            -3.30090681943584
         ],
         [
            -4.043580053463491,
            -0.749484121799469,
            -2.5290720170486365
         ]
      ]
   }
}
